import React, { ReactElement } from 'react';
import {
  Col, Row, Text,
} from 'idsk-react-components';
import './predpisCudziJazykMobileTableItem.scss';
import PredpisCudziJazyk from '../../../model/PredpisCudziJazyk';

interface Props {
  predpisSk: string,
  predpisCudzi: string,
  predpisyCudziJazyk: PredpisCudziJazyk,
  actions: ReactElement,
}

const PredpisCudziJazykMobileTableItem = ({
  predpisSk,
  predpisCudzi,
  predpisyCudziJazyk,
  actions,
}: Props): ReactElement => (
  <Col className="dokument-detail">
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            {predpisyCudziJazyk?.nadpisStlpecPrvySk}
          </div>
          {predpisyCudziJazyk?.nadpisStlpecPrvyCudzi && <br />}
          {predpisyCudziJazyk?.nadpisStlpecPrvyCudzi}
        </Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{predpisSk}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            {predpisyCudziJazyk?.nadpisStlpecDruhySk}
          </div>
          {predpisyCudziJazyk?.nadpisStlpecDruhyCudzi && <br />}
          {predpisyCudziJazyk?.nadpisStlpecDruhyCudzi}
        </Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{predpisCudzi}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      {actions}
    </Row>
  </Col>
);

export default PredpisCudziJazykMobileTableItem;
